import { Reveal, Eyebrow } from "./Reveal";

export default function DemoVideo() {
  return (
    <section data-testid="demo-video-section" className="border-t border-white/[0.06] py-24 lg:py-28">
      <div className="mx-auto max-w-4xl px-5 text-center sm:px-8">
        <Reveal>
          <Eyebrow>Watch It Work</Eyebrow>
          <h2 className="mx-auto mt-4 max-w-2xl font-display text-2xl font-bold tracking-tight text-slate-50 sm:text-3xl lg:text-4xl">
            Watch Backfill book a job in 20 seconds
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base text-slate-400">
            A real run of the automatic demo — missed call in, qualified and
            booked job out. No human touched it. Narrated — sound on.
          </p>
        </Reveal>
        <Reveal delay={0.12}>
          <div className="relative mt-10 overflow-hidden rounded-xl border border-white/[0.1] shadow-[0_40px_80px_-20px_rgba(0,0,0,0.7)]">
            <span className="absolute left-0 top-0 z-10 h-5 w-5 border-l-2 border-t-2 border-[#F25F22]" />
            <span className="absolute right-0 top-0 z-10 h-5 w-5 border-r-2 border-t-2 border-[#F25F22]" />
            <span className="absolute bottom-0 left-0 z-10 h-5 w-5 border-b-2 border-l-2 border-[#F25F22]" />
            <span className="absolute bottom-0 right-0 z-10 h-5 w-5 border-b-2 border-r-2 border-[#F25F22]" />
            <video
              controls
              preload="metadata"
              data-testid="demo-video"
              className="w-full bg-black"
            >
              <source src="/backfill-demo.mp4" type="video/mp4" />
              <source src="/backfill-demo.webm" type="video/webm" />
              Your browser does not support the video tag.
            </video>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
